import type { Container } from "pixi.js";
import { GameScene } from "../scene/GameScene";
import type { MergeCandyHook } from "./MergeCandyHook";

/**
 * Adds mergecandy's members to the shell's hook: the scene is found on the stage, its board read through the readout
 * the round presentation set; a node's drawn alpha is read up its ancestors (the shell's `isShown` reads `visible` only),
 * its tint as it is set (the cell multiplier badges colour the tiles).
 */
export function installMergeCandyHook(input: { hook: object; stage: Container }): void {
  const scene = findScene(input.stage);
  const members: MergeCandyHook = {
    getBoard: () => scene?.readBoard() ?? [],
    getDrawnAlpha: (label) => {
      let node = findShown(input.stage, label);
      let alpha = node ? 1 : 0;
      for (; node; node = node.parent) alpha *= node.alpha;
      return alpha;
    },
    getTint: (label) => findShown(input.stage, label)?.tint ?? null,
  };
  Object.assign(input.hook, members);
}

/** The first node labelled `label` inside a visible subtree. */
function findShown(root: Container, label: string): Container | null {
  if (!root.visible) return null;
  if (root.label === label) return root;
  for (const child of root.children) {
    const hit = findShown(child, label);
    if (hit) return hit;
  }
  return null;
}

function findScene(node: Container): GameScene | null {
  if (node instanceof GameScene) return node;
  for (const child of node.children) {
    const found = findScene(child);
    if (found) return found;
  }
  return null;
}
